module.exports = __webpack_public_path__ + "static/media/fitness-retreat-guest-icon.a66ca736.svg";